import { Button, Typography } from 'antd';
import { FileTwoTone, CloseOutlined } from '@ant-design/icons';
import { Delete } from '../Delete';
import classes from './AttachExcel.module.scss';

type AttachedExcelType = {
  remove: (file: File) => void;
  files: File[];
};

export function AttachedExcel(props: AttachedExcelType) {
  const { remove, files } = props;

  return (
    <>
      {files.map((file) => (
        <div className={classes.attachedExcelFile} key={file.name}>
          <span className={classes.title}>
            <FileTwoTone />
            <Typography.Paragraph ellipsis className={classes.fileName}>
              {file.name}
            </Typography.Paragraph>
          </span>
          <Delete name={file.name} onConfirm={() => remove(file)}>
            <Button
              type="link"
              className={classes.deleteBtn}
              icon={<CloseOutlined className={classes.deleteIcon} />}
            />
          </Delete>
        </div>
      ))}
    </>
  );
}
